import React, { useState } from "react";
import checkImage from "../../assests/images/check-circle.png";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Link, useNavigate } from "react-router-dom";
import { isEmptyDash } from "../../constant";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import { authServices } from "../../services/authServices";
import logoImage from "../../assests/images/logo.png";

function ResetPassword(props) {
  const [isPassword, setIsPassword] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isValidPassword, setIsValidPassword] = useState(true);
  const [credential, setCredential] = useState({
    password: "",
    confirmPassword: "",
  });
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });
  let navigate = useNavigate();
  const [showResetSuccessModal, setShowResetSuccessModal] = useState(false);

  const onInputChange = (e) => {
    const { name, value } = e.target;
    setCredential((prevCredential) => ({
      ...prevCredential,
      [name]: value,
    }));
  };

  const passwordViewChange = () => {
    setIsPassword((prevIsPassword) => !prevIsPassword);
  };

  const submitResetPassword = () => {
    // Use axios or any other method to submit the reset password
    // You can also validate the form before submitting 
    let regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;
    
    // console.log(credential?.password, regex.test(credential?.password));

    if (regex.test(credential?.password) == false) {
      props.openAlert(true, "error", `Please Enter Valid Password.`);
      setIsValidPassword(true);      
      return;
    }

    if (isEmptyDash(credential?.password)) {
      props.openAlert(true, "error", `Please Enter Password.`);
      return;
    }
    if (isEmptyDash(credential?.confirmPassword)) {
      props.openAlert(true, "error", `Please Enter Confirm Password.`);
      return;
    }

    if (credential?.password == credential?.confirmPassword) {
      let obj = {
        password: credential?.password,
      };
      setNewPassword(obj, props?.accessUser?.user?.accessToken);

      // setShowResetSuccessModal(true); // Show the reset success modal
    } else {
      props.openAlert(true, "error", `Please enter same Password.`);
      return;
    }
    // props.submitResetPassword(2);
  };

  const handleCloseResetSuccessModal = () => {
    setShowResetSuccessModal(false);
    let path = `/auth/login`;
    navigate(path);
  };

  const handleClose = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };

  const setNewPassword = (data, token) => {
    setIsLoading(true);
    authServices
      .createPassword(data, token)
      .then(function (response) {
        setShowResetSuccessModal(true);
        props.openAlert(
          true,
          "success",
          `Your password has been changed successfully.`
        );
        navigateToLogin("/auth/login", 2000);
      })
      .catch(function (error) {
        props.openAlert(true, "error", `${error?.response?.data?.message}`);
        navigateToLogin("/auth/login", 2000);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const navigateToLogin = (url, time) => {
    setTimeout(() => {
      navigate(url);
    }, time);
  };

  return (
    <>
      <div className="text-center">
        <div className="logo_login_react_vendors">
          <img src={logoImage} alt="" height="51" />
        </div>
        <h3 className="titles">{(props?.accessUser?.user?.newUser) ? "Create " : "Reset"} Password</h3>
        <p>Enter a new password to login to your account.</p>


        {(props?.accessUser?.user?.newUser) && <>
          <h3 className="titles" style={{ marginTop: "12px" }}> Username: {props?.accessUser?.user?.userName} </h3>
          <p>Note: Kindly note down your username for login.</p>
        </>}


      </div>
      <form>
        <div className="mb-4 position-relative">
          <label className="mb-1 text-dark">New Password</label>
          <input
            type="text"
            name="password"
            className="form-control form-h"
            onChange={onInputChange}
            value={credential?.password}
            placeholder="Enter your password"
          />

          <span className="lock">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="19"
              height="19"
              fill="currentColor"
              className="bi bi-lock"
              viewBox="0 0 16 16"
            >
              <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2m3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1" />
            </svg>
          </span>
        </div>

        <div className="mb-4 position-relative">
          <label className="mb-1 text-dark">Confirm Password</label>
          <input
            type={isPassword ? "password" : "text"}
            name="confirmPassword"
            className="form-control form-h"
            onChange={onInputChange}
            value={credential?.confirmPassword}
            placeholder="Confirm your password"
          />
          <span className="lock">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="19"
              height="19"
              fill="currentColor"
              className="bi bi-lock"
              viewBox="0 0 16 16"
            >
              <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2m3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1" />
            </svg>
          </span>

          <span className="show-pass eye" onClick={passwordViewChange}>
            {isPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
          </span>
        </div>

        <div className="text-center mb-4">
          <Button
            onClick={submitResetPassword}
            class="btn btn-primary btn-log reset-btn"
          >
            {/* Reset Password */}
            Create Password
          </Button>
          <Modal
            open={showResetSuccessModal} // Fix: use showResetSuccessModal instead of open
            onClose={handleCloseResetSuccessModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              className="lets_block_modal_listing"
              sx={{
                position: "absolute",
                width: 400,
                bgcolor: "background.paper",
                border: "2px solid #000",
                p: 2,
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <div className="text-center">
                <div class="modal-header">
                  <h5 class="modal-title" id="contactModalLabel"></h5>
                  <button
                    type="button"
                    class="btn-close"
                    data-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="7f6r2r"
                  ></button>
                </div>
                <img src={checkImage} alt="" />
                <h6 className="react_modal_changed_password">
                  Password Changed
                </h6>
                <Typography className="vendor_succrssfully_block_main">
                  Your password has been change successfully
                </Typography>
                <Button
                  className="btn-success "
                  onClick={handleCloseResetSuccessModal}
                  sx={{ mt: 2, color: "green" }}
                >
                  Done
                </Button>
              </div>
            </Box>
          </Modal>
        </div>
        
        {(isValidPassword) && <div className="resetsection_passowrdrow">
            <p className="password_section_vali">Password Validation</p>
            <ul>
              <li className="lisection_Row">
                At least one digit (0-9).
              </li>
              <li className="lisection_Row">
                At least one lowercase letter (a-z).
              </li>
              <li className="lisection_Row">
                At least one uppercase letter (A-Z).
              </li>
              <li className="lisection_Row">
                At least one special character.
              </li>
              <li className="lisection_Row">
                A minimum length of 8 characters.
              </li>
              <li className="lisection_Row">
                No whitspaces
              </li>
            </ul>
          </div>}

      </form>

      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleClose}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default ResetPassword;
